import * as React from 'react';
import Popover from '@mui/material/Popover';
import { Box, IconButton } from '@mui/material';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { colors } from 'styles/colors';
import DeleteRegistryButton from '../DeleteRegistryButton/DeleteRegistryButton';
// import RevokeUserButton from '../RevokeUserButton/RevokeUserButton';

interface Props {
  registryId: number;
  registryName: string;
  refetch?: () => void;
}

export default function RegistryItemOptions(props: Props) {
  const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(null);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;

  return (
    <div>

      <IconButton onClick={handleClick} sx={{ padding: 0 }} disableRipple>
        <MoreVertIcon sx={{ color: colors.secondary }} />
      </IconButton>

      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'center',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            borderRadius: '10px',
            overflow: 'hidden',
            maxWidth: '200px'
          }}
          p={1}
        >
          <DeleteRegistryButton {...props} onClose={() => setAnchorEl(null)} />
        </Box>
      </Popover>
    </div>
  );
}
